import React, { useEffect, useState } from 'react';
import PowerBIReport from '../PowerBIReport';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import apiService from 'src/services/apiService';

const PowerBIDashboard = ({ workspaceId, intl, setShowBI }) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [reports, setReports] = useState<[{ name: string; id: string }] | []>(
    [],
  );
  const [reportId, setReportId] = useState<string | null>(null);

  const getAccessToken = async () => {
    try {
      const localToken = localStorage.getItem('token');
      await apiService
        .get('/user/token', {
          headers: { Authorization: `Bearer ${localToken}` },
        })
        .then(response => {
          const accessToken = response.data?.access_token;
          if (accessToken) {
            setAccessToken(accessToken);
          } else {
            setShowBI(false);
          }
        })
        .catch(error => {
          console.error(error);
          setShowBI(false);
        });
    } catch (err) {
      console.error(err);
    }
  };

  const getReportIds = async () => {
    await fetch(
      `https://api.powerbi.com/v1.0/myorg/groups/${workspaceId}/reports`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )
      .then(async response => {
        const data = await response.json();
        setReports(data.value);
      })
      .catch(error => {
        console.error(error);
        setShowBI(false);
      });
  };

  const handleSelect = event => {
    setReportId(event.target.value);
  };

  useEffect(() => {
    getAccessToken();
  }, []);

  useEffect(() => {
    if (accessToken !== null) {
      getReportIds();
    }
  }, [accessToken]);

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: '15px',
      }}
    >
      {reports.length ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '15px',
          }}
        >
          <FormControl style={{ width: '50%' }} variant="outlined">
            <InputLabel id="report-select-label">
              {intl.messages['powerbi.select.title']}
            </InputLabel>
            <Select
              labelId="report-select-label"
              id="report-select"
              value={reportId}
              label={intl.messages['powerbi.select.title']}
              onChange={handleSelect}
            >
              {reports.map(report => (
                <MenuItem key={report.id} value={report.id}>
                  {report.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      ) : null}
      {accessToken && reportId ? (
        <PowerBIReport
          accessToken={accessToken}
          workspaceId={workspaceId}
          reportId={reportId}
        />
      ) : null}
    </div>
  );
};

export default PowerBIDashboard;
